import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Star } from "lucide-react";
import { COURSES, COURSE_CATALOG } from "@/data/site";

export const Courses = () => {
  return (
    <section id="corsi" className="relative py-24 sm:py-32 bg-ink-800/40">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <h4 className="text-xs uppercase tracking-[0.3em] text-gold-500 font-sans mb-5">
              Discipline
            </h4>
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-white leading-tight">
              Un percorso <span className="italic text-gold-500">per ogni voce.</span>
            </h2>
          </div>
          <p className="text-sm text-gray-400 max-w-sm">
            Strumenti classici e moderni, canto e teatro. Ogni corso con
            preparazione opzionale ai grade Trinity College London.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-3 mb-12">
          <span className="text-xs uppercase tracking-[0.2em] text-gray-500">Generi</span>
          {["Classico", "Pop / Rock", "Jazz"].map((g) => (
            <span
              key={g}
              data-testid={`genre-${g}`}
              className="rounded-full border border-gold-500/30 bg-gold-500/10 px-4 py-1.5 text-sm text-gold-400"
            >
              {g}
            </span>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 auto-rows-[280px]">
          {COURSES.map((c, i) => (
            <motion.div
              key={c.key}
              data-testid={`course-card-${c.key}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`group relative overflow-hidden rounded-2xl border border-white/10 ${c.span} ${c.h}`}
            >
              <img
                src={c.img}
                alt={c.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/50 to-black/30" />
              {c.highlight && (
                <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-gold-500 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-ink-900">
                  <Star size={12} /> Unici in provincia
                </div>
              )}
              <div className="absolute inset-x-0 bottom-0 p-6">
                <p className="text-[11px] uppercase tracking-[0.2em] text-gold-500 mb-2">
                  {c.tag}
                </p>
                <h3 className="font-serif text-2xl sm:text-3xl text-white">{c.title}</h3>
                <p className="mt-2 text-sm text-gray-300 max-w-md opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                  {c.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Full catalog — all active courses */}
        <div className="mt-20">
          <div className="flex items-center gap-4 mb-10">
            <span className="h-px flex-1 bg-white/10" />
            <h3 className="font-serif text-2xl sm:text-3xl text-white text-center">
              Tutti i corsi attivi <span className="text-gold-500">· 22 discipline</span>
            </h3>
            <span className="h-px flex-1 bg-white/10" />
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {COURSE_CATALOG.map((group, i) => {
              const Icon = Icons[group.icon] || Icons.Music;
              return (
                <motion.div
                  key={group.category}
                  data-testid={`catalog-group-${i}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.45, delay: i * 0.05 }}
                  className="rounded-2xl border border-white/10 bg-ink-800 p-6 hover:border-gold-500/40 transition-colors duration-300"
                >
                  <div className="flex items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold-500/10 border border-gold-500/20 text-gold-500">
                      <Icon size={18} />
                    </div>
                    <h4 className="text-xs uppercase tracking-[0.2em] text-gold-500">
                      {group.category}
                    </h4>
                  </div>
                  <ul className="mt-5 space-y-2.5">
                    {group.items.map((item) => (
                      <li key={item} className="flex items-start gap-2.5 text-sm text-gray-300">
                        <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gold-500/70" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </motion.div>
              );
            })}
          </div>
          <p className="mt-8 text-center text-sm text-gray-500">
            Corsi per bambini, ragazzi e adulti · Livelli dal principiante all'avanzato ·
            Preparazione opzionale ai grade Trinity College London
          </p>
        </div>
      </div>
    </section>
  );
};
